import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { WorkerReference } from './type';

const getToken = () => localStorage.getItem('token');

const getAuthorizationHeader = () => {
  const token = getToken();
  return token ? `Bearer ${token}` : '';
};

export const referencesApi = createApi({
  reducerPath: 'referencesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}/api/customer/docs`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: getAuthorizationHeader(),
    },
  }),
  endpoints: (builder) => ({
    getWorkerReferences: builder.query<WorkerReference[], { id: string }>({
      query: ({ id }) => ({
        url: `/registration-reference/${id}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetWorkerReferencesQuery } = referencesApi;
